import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from 'mdbreact';
import { CSVLink } from "react-csv";
import dayjs from 'dayjs';
import { DatePicker, Select } from "antd";
import { currency, dateFormat, timeFormat } from "../../../../dynamicController";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Loading from "../Loading";

const { RangePicker } = DatePicker;

const mySwal = withReactContent(Swal);

const TokenReportCard = ({ role, token, country, operators, distributors, outlets }) => {

    const { t } = useTranslation();

    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [topChoice, setTopChoice] = useState(null)
    const [totalAmount, setTotalAmount] = useState(0)
    const [totalTokens, setTotalTokens] = useState(0)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [userCountry, setUserCountry] = useState("")
    const [operatorId, setOperatorId] = useState(null)
    const [distributorId, setDistributorId] = useState(null)
    const [outletId, setOutletId] = useState([])
    const [operatorOption, setOperatorOpion] = useState([])
    const [distributorOption, setDistributorOption] = useState([])
    const [outletOption, setOutletOption] = useState([])

    useEffect(() => {
        if (outlets) {
            let outletList = []
            let filterOutlet = outlets
            if (distributorId) {
                filterOutlet = outlets.filter(outlet => outlet.distributorId === distributorId)
            }
            if (operatorId) {
                filterOutlet = outlets.filter(outlet => outlet.adminId === operatorId)
            }
            for (let i = 0; i < filterOutlet.length; i++) {
                let outletObject = {
                    value: filterOutlet[i].id,
                    label: `${filterOutlet[i].outlet_fullname} (${filterOutlet[i].outlet_name})`
                }
                outletList.push(outletObject)
            }
            setOutletOption(outletList)
        }
    }, [outlets, operatorId, distributorId])

    useEffect(() => {
        if (operators) {
            let operatorList = []
            let filterOperator = operators
            if (distributorId) {
                filterOperator = operators.filter(operator => operator.distributorId === distributorId)
            }
            for (let i = 0; i < filterOperator.length; i++) {
                let operatorObject = {
                    value: filterOperator[i].id,
                    label: filterOperator[i].username
                }
                operatorList.push(operatorObject)
            }
            setOperatorOpion(operatorList)
        }
    }, [operators, distributorId])

    useEffect(() => {
        if (distributors) {
            let distributorList = []
            for (let i = 0; i < distributors.length; i++) {
                let distributorObject = {
                    value: distributors[i].id,
                    label: distributors[i].name
                }
                distributorList.push(distributorObject)
            }
            setDistributorOption(distributorList)
        }
    }, [distributors])

    useEffect(() => {
        if (role !== "distributor" && role !== "client") {
            setLoading(true)
            axios
                .post("/api/admin/report/token", { startDate, endDate, outletIds: outletId, operatorId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.tableData)
                    setTopChoice(res.data.topChoice)
                    setTotalAmount(res.data.totalAmount)
                    setTotalTokens(res.data.totalTokens)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }, [])

    const handleDate = (dates, dateStrings) => {
        if (dates) {
            setStartDate(dateStrings[0])
            setEndDate(dateStrings[1])
        } else {
            setStartDate("")
            setEndDate("")
        }
    };

    const handleReset = () => {
        setStartDate("")
        setEndDate("")
        setOperatorId(null)
        setDistributorId(null)
        setOutletId([])
        setData([])
        setTopChoice(null)
        setTotalAmount(0)
        setTotalTokens(0)
        setUserCountry("")
        if (role !== "client" && role !== "distributor") {
            setLoading(true)
            axios
                .post("/api/admin/report/token", {}, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.tableData)
                    setTopChoice(res.data.topChoice)
                    setTotalAmount(res.data.totalAmount)
                    setTotalTokens(res.data.totalTokens)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const handleFilter = () => {
        if ((role === "client" || role === "distributor") && !operatorId) {
            mySwal.fire(t("Error"), t("Please select operator"), "error")
        } else {
            setLoading(true)
            axios
                .post("/api/admin/report/token", { startDate, endDate, operatorId, outletIds: outletId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.tableData)
                    setTopChoice(res.data.topChoice)
                    setTotalAmount(res.data.totalAmount)
                    setTotalTokens(res.data.totalTokens)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }

    const handleChangeDistributor = (value) => {
        setDistributorId(value)
        setOperatorId(null)
        if (value) {
            setUserCountry(distributors.filter(distributor => distributor.id === value)[0].country)
        } else {
            setUserCountry("")
        }
    }

    const handleChangeOperator = (value) => {
        setOperatorId(value)
        if (value) {
            let selectedOperator = operators.filter(operator => operator.id === value)[0]
            let selectedCountry = selectedOperator.country
            if (selectedOperator.distributorId) {
                let selectedDistributor = distributors.filter(distributor => distributor.id === selectedOperator.distributorId)[0]
                if (selectedDistributor) {
                    selectedCountry = selectedDistributor.country
                }
            }
            setUserCountry(selectedCountry)
        } else {
            setUserCountry("")
        }
    }

    const handleChangeOutlet = (value) => {
        setOutletId(value)
        if (!operatorId && (role === "client" || role === "distributor")) {
            let selectedOutlet = outlets.filter(outlet => outlet.id === value[0])[0]
            if (selectedOutlet) {
                handleChangeOperator(selectedOutlet.adminId)
            }
        }
    }

    const checkDetails = (outletName) => {
        history.push(`/${role === "operator" ? "admin" : role}/token/report/detail`, { outletName, startDate, endDate });
    }

    let tableData = {
        columns: [
            {
                label: t("Outlet Name"),
                field: "outletName",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-token used in all the transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total e-Token Collected")}</span>
                    </OverlayTrigger>
                ),
                field: "tokenCollected",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-token used in washer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Washer e-Token Collected")}</span>
                    </OverlayTrigger>
                ),
                field: "washerTokens",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-token used in dryer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Dryer e-Token Collected")}</span>
                    </OverlayTrigger>
                ),
                field: "dryerTokens",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-token used in vending machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Vending Machine e-Token Collected")}</span>
                    </OverlayTrigger>
                ),
                field: "vendingTokens",
                sort: "asc"
            }
        ],
        rows: []
    };

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const dataObject = {
                ...data[i],
                outletName: (
                    <button type="button" className="btn btn-link" onClick={() => checkDetails(data[i].outletName)}>
                        {data[i].outletName}
                    </button>
                )
            }
            tableData.rows.push(dataObject)
        }
    }

    const csvData = {
        headers: [
            { label: "Outlet Name", key: "outletName" },
            { label: "Total e-Token Collected", key: "tokenCollected" },
            { label: "Washer e-Token Collected", key: "washerTokens" },
            { label: "Dryer e-Token Collected", key: "dryerTokens" }
        ],
        data
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <h5 className="card-title">{t("Token Report")}</h5>

                <button className="btn btn-primary" onClick={() => history.push(`/${role === "operator" ? "admin" : role}/token/report/purchasehistory`)}>
                    {t("Purchase History")}
                </button>
            </div>

            <div className="card-body">
                <div className="mb-5">
                    <h6>{t("Filter")}</h6>
                    {
                        role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="distributorId">{t("Select Distributor")}: </label>
                                <Select
                                    id="distributorId"
                                    name="distributorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Distributor")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeDistributor(value)}
                                    options={distributorOption}
                                    value={distributorId}
                                />
                            </div>
                        ) : null
                    }

                    {
                        role === "distributor" || role === "client" ? (
                            <div className="mb-3">
                                <label htmlFor="operatorId">{t("Select Operator")}: </label>
                                <Select
                                    id="operatorId"
                                    name="operatorId"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("Select Operator")}
                                    showSearch
                                    optionFilterProp="label"
                                    onChange={(value) => handleChangeOperator(value)}
                                    options={operatorOption}
                                    value={operatorId}
                                />
                            </div>
                        ) : null
                    }

                    <div className="mb-3">
                        <label htmlFor="outletId">{t("Select Outlet")}: </label>
                        <Select
                            mode="multiple"
                            id="outletId"
                            name="outletId"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={t("Select Outlet")}
                            showSearch
                            optionFilterProp="label"
                            onChange={(value) => handleChangeOutlet(value)}
                            options={outletOption}
                            value={outletId}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="date">{t("Select Transaction Date")}: </label>
                        <RangePicker
                            id="date"
                            name="date"
                            placeholder={[t("Start date"), t("End date")]}
                            onChange={handleDate}
                            style={{ width: '100%' }}
                            value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : []}
                            presets={[
                                { label: t("Today"), value: [dayjs(), dayjs()] },
                                { label: t("Yesterday"), value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
                                { label: t("Last 7 Days"), value: [dayjs().subtract(6, 'day'), dayjs()] },
                                { label: t("Last 30 Days"), value: [dayjs().subtract(29, 'day'), dayjs()] },
                                { label: t("This Month"), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                                { label: t("Last Month"), value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
                            ]}
                        />
                    </div>

                    <div className="d-flex">
                        <button onClick={() => handleFilter()} className="btn btn-primary btn-inline form-control me-3">
                            {t("Filter")}
                        </button>
                        <button onClick={() => handleReset()} className="btn btn-secondary btn-inline form-control ms-3">
                            {t("Reset")}
                        </button>
                    </div>
                </div>

                <div className="mt-5">
                    {
                        loading ? <Loading /> : (
                            <div>
                                <div>
                                    <p>
                                        {t("Most Bought e-Token Package")} :{" "}
                                        <strong>
                                            [ {country || userCountry ? currency(country || userCountry) : ""}{topChoice ? topChoice.price.toFixed(2) : 0} {t("for")} {topChoice ? topChoice.token : 0} {t("Tokens")} ]
                                        </strong>
                                    </p>
                                    <p>
                                        {t("Total Earned from users buying e-Tokens")}: <strong>{country || userCountry ? currency(country || userCountry) : ""}{totalAmount.toFixed(2)}</strong>
                                    </p>
                                    <p>
                                        {t("Total e-Tokens Bought from you")}: <strong>{totalTokens} {t("Tokens")}</strong>
                                    </p>
                                </div>
                                <div className="text-center">
                                    <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`token_report_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                            {t("Download Report")}
                                        </CSVLink>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default TokenReportCard;